

import * as Configuration from '../../../app.constants.js';

export class PriorityRulesService {
  constructor($http, DropdownItemsFactory) {
    this.$http = $http;
    this.DropdownItemsFactory = DropdownItemsFactory;
  }

  _priorityRulesURL(companyId) {
    return Configuration.constants.baseUrl + 'api/1.0/companies/' + companyId + '/parameters/push-mode/priority-rules';
  }

  getPriorityRules(companyId) {
    return this.$http.get(this._priorityRulesURL(companyId));
  }

  updatePriorityRules(companyId, config) {
    return this.$http.put(this._priorityRulesURL(companyId), config);
  }

  buildDropdownItems(sites, tagsGroups) {
    return {
      'sites':    this.DropdownItemsFactory.buildSiteItems(sites), 
      'channels': this.DropdownItemsFactory.buildChannelItems(sites),
      'weekDays': this.DropdownItemsFactory.buildWeekDays(),
      'bhNbh':    this.DropdownItemsFactory.buildBhNbh(),
      'tags':     this.DropdownItemsFactory.buildTagItems(tagsGroups)
    }
  } 

  static PriorityRulesFactory($http, DropdownItemsFactory) {
    return new PriorityRulesService($http, DropdownItemsFactory);
  }
}

PriorityRulesService.PriorityRulesFactory.$inject = ['$http', 'DropdownItemsFactory'];

